<template>
  <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.39355 0.695312L0.538086 6.61328V13.7617H7.39355V0.695312ZM16.5635 0.695312L9.56152 6.61328V13.7617H16.5635V0.695312Z" fill="#D64633"/>
  </svg>
</template>